import { z } from 'zod';
import { requestWithZod } from '..';
import { MOON_DRAW_AMOUNT } from '@/components/features/casino/moon-draw/config';

export const moonDrawBet = async (amount = MOON_DRAW_AMOUNT) => {
  return await requestWithZod({
    url: '/api/game/draw/bet',
    method: 'post',
    data: {
      amount,
    },
    schema: z.object({
      payout: z.string(),
      userName: z.string(),
      amount: z.string(),
      result: z.string(),
      win: z.boolean(),
      currency: z.string(),
      multiplier: z.string(),
    }),
  });
};

export const SMoonDrawHistory = z.object({
  nextId: z.string().optional(),
  hasNext: z.boolean().optional(),
  hasPrev: z.boolean().optional(),
  prevId: z.string().optional(),
  list: z.array(
    z.object({
      id: z.string(),
      gameId: z.string(),
      uid: z.string(),
      userName: z.string(),
      amount: z.string(),
      payout: z.string(),
      multiplier: z.string(),
      hash: z.string(),
      result: z.string(),
      clientSeed: z.string(),
      createdTime: z.string(),
    }),
  ),
});

export const getMoonDrawHistory = async ({
  pageSize = 5,
  prevId = undefined,
  nextId = undefined,
  page = undefined,
}) => {
  return await requestWithZod({
    url: '/api/game/draw/records',
    method: 'post',
    data: {
      pageSize,
      prevId,
      nextId,
    },
    schema: SMoonDrawHistory,
  });
};
